import { useEffect, useState } from "react";
import getInfoByUrl from "../Services/getInfoByUrl";
import PokeType from "./PokeType";
import { Link } from "react-router-dom";

const PokeItem = ({ url }) => {
  const [pokeObj, setPokeObj] = useState({});
  const [pokeImg, setPokeImg] = useState("");
  const [typesArr, setTypesArr] = useState([]);
  const [hp, setHp] = useState(0);
  const [dataPokemon, setDataPokemon] = useState({});
  const [pokeId, setPokeId] = useState(null);

  useEffect(() => {
    getInfoByUrl(url).then((res) => {
      setPokeObj(res.data);
      setPokeImg(res.data.sprites.front_default);
      setTypesArr(res.data.types);
      setHp(res.data.stats[0].base_stat);
      setDataPokemon({
        type: res.data.types,
        image: res.data.sprites.front_default,
        hp: res.data.stats[0].base_stat,
        attack: res.data.stats[1].base_stat,
        defense: res.data.stats[2].base_stat,
        speed: res.data.stats[5].base_stat,
      });
      setPokeId(res.data.id);
    });
  }, [url]);

  const list = typesArr.map((item) => (
    <PokeType key={item.slot} type={item.type} />
  ));
  return (
    <Link to={`/pokedex/${pokeId}`}>
      <div
        style={{
          margin: "1.5vw",
          padding: "0.05vw",
          backgroundColor: "#333",
          borderRadius: "8px",
        }}
      >
        <p className="white05 t-title">{pokeObj.name}</p>
        <div className="cColumns cColumns2">
          <div>
            <span className="cFilas white05 b-radius-S">
              <div>type:</div>
              {list}
            </span>
            <p className="white05 b-radius-S">HP: {dataPokemon.hp}</p>
            <p className="white05 b-radius-S">attack: {dataPokemon.attack}</p>
            <p className="white05 b-radius-S">defense: {dataPokemon.defense}</p>
            <p className="white05 b-radius-S">speed: {dataPokemon.speed}</p>
          </div>
          <img src={pokeImg} alt="" style={{ height: "20vh " }} />
        </div>
      </div>
    </Link>
  );
};

export default PokeItem;
